import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import UnitItemListService from '../../../services/UnitItemListService';
import UnitItemList from './UnitItemList';
import CreateUnitItemDraftService from '../../../services/CreateUnitItemDraftService';
import UnitItemListActionsService from '../../../services/UnitItemListActionsService';

class UnitItemListContainer extends Component {
  static propTypes = {
    unit: PropTypes.shape({
      id: PropTypes.string.isRequired,
      createdBy: PropTypes.string.isRequired,
    }).isRequired,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
  };

  componentWillMount() {
    UnitItemListService.init(this.props.unit);
  }

  render() {
    return (
      <UnitItemList
        unit={this.props.unit}
        items={toJS(UnitItemListService.items)}
        submitting={UnitItemListService.submit.fetching}
        fetching={
          UnitItemListService.fetch.fetching ||
          UnitItemListService.reorderSubmitting ||
          UnitItemListService.submit.fetching ||
          UnitItemListActionsService.submit.fetching
        }
        onDelete={UnitItemListService.handleRemove}
        onOrderOrGroupChange={UnitItemListService.handleOrderOrGroupChange}
        onAutoReorder={UnitItemListService.handleAutoReorder}
        disabled={this.props.disabled}
        onDraft={CreateUnitItemDraftService.handleShow}
        onPublish={UnitItemListService.handlePublish}
        onUnpublish={UnitItemListService.handleUnpublish}
        selectable={UnitItemListService.selectable}
        onSelectRows={UnitItemListService.handleSelectRows}
        selectedRows={toJS(UnitItemListService.selectedRows)}
        getCheckboxProps={UnitItemListService.getCheckboxProps}
      />
    );
  }
}

export default observer(UnitItemListContainer);
